import React from "react";
import { cn } from "@/lib/utils";

interface RainbowButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "white" | "dark";
  customBg?: string; // hex or tailwind color class
}

export function RainbowButton({
  children,
  className,
  variant = "default",
  customBg,
  ...props
}: RainbowButtonProps) {
  return (
    <button
      className={cn(
        "group relative flex h-20 sm:h-16 cursor-pointer items-center justify-center rounded-2xl border-0 px-12 py-4 text-lg font-medium font-sans transition-colors [background-clip:padding-box,border-box,border-box] [background-origin:border-box] [border:calc(0.08*1rem)_solid_transparent] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
        !customBg && "animate-rainbow bg-[length:200%]",

        // before styles
        !customBg && (
          variant === "dark"
            ? "before:absolute before:bottom-[-20%] before:left-1/2 before:z-0 before:h-1.5 before:w-3/5 before:-translate-x-1/2 before:animate-rainbow before:bg-[linear-gradient(90deg,#ff0000,#ff8000,#ffff00,#00ff00,#00ffff,#0000ff,#8000ff,#ff00ff)] before:bg-[length:200%] before:[filter:blur(calc(1.2*1rem))]"
            : "before:absolute before:bottom-[-20%] before:left-1/2 before:z-0 before:h-1.5 before:w-3/5 before:-translate-x-1/2 before:animate-rainbow before:bg-[linear-gradient(90deg,#ff0000,#ff8000,#ffff00,#00ff00,#00ffff,#0000ff,#8000ff,#ff00ff)] before:bg-[length:200%] before:[filter:blur(calc(0.8*1rem))]"
        ),

        customBg
          ? `!bg-[${customBg}] !text-black`
          : variant === "white"
          ? "bg-white/90 text-neutral-900"
          : variant === "dark"
          ? "bg-white/90 text-neutral-900"
          : [
              // light mode colors
              "bg-[linear-gradient(hsl(var(--primary)),hsl(var(--primary))),linear-gradient(hsl(var(--primary))_50%,rgba(18,18,19,0.6)_80%,rgba(18,18,19,0)),linear-gradient(90deg,#ff0000,#ff8000,#ffff00,#00ff00,#00ffff,#0000ff,#8000ff,#ff00ff)]",
              // dark mode colors
              "dark:bg-[linear-gradient(hsl(var(--primary)),hsl(var(--primary))),linear-gradient(hsl(var(--primary))_50%,rgba(255,255,255,0.6)_80%,rgba(0,0,0,0)),linear-gradient(90deg,hsl(var(--color-1)),hsl(var(--color-5)),hsl(var(--color-3)),hsl(var(--color-4)),hsl(var(--color-2)))]",
              "text-primary-foreground"
            ],

        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
} 